import { getRequest, postRequest } from './api'

export async function find(id) {
  return getRequest(`language/edit/${id}`)
}
export async function save(values) {
  return postRequest(`language/save`, values)
}
 